var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("div", { staticClass: "row" }, [
          _c("div", { staticClass: "col-xs-12 col-md-8" }, [
            _c("h1", [
              _vm._v("Custom Notification #" + _vm._s(_vm.notification.id)),
            ]),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "col-md-4 hidden-xs hidden-sm" }, [
            _c("div", { staticClass: "booking-status" }, [
              _c("div", { staticClass: "row" }, [
                _c("p", [
                  _c("span", { class: _vm.percentageClass }, [
                    _vm._v(_vm._s(_vm.talentResponseRate)),
                  ]),
                ]),
              ]),
            ]),
          ]),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("h2", [_vm._v("Notification details")]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-item__row" },
          _vm._l(_vm.calculatedFields, function (field) {
            return _c(
              "div",
              {
                key: field.label,
                staticClass: "form-item__field",
                class: field.full ? "form-item__field--full" : "",
              },
              [
                _c(
                  "div",
                  { staticClass: "input-group input-group-booking-detail" },
                  [
                    _c("span", { staticClass: "input-group-addon" }, [
                      _vm._v(_vm._s(field.label)),
                    ]),
                    _vm._v(" "),
                    field.html
                      ? _c("div", {
                          staticClass: "form-control",
                          domProps: { innerHTML: _vm._s(field.content) },
                        })
                      : _c("p", { staticClass: "form-control" }, [
                          _vm._v(_vm._s(field.content)),
                        ]),
                  ]
                ),
              ]
            )
          }),
          0
        ),
      ]),
      _vm._v(" "),
      _vm.responseNotification
        ? _c(
            "div",
            { staticClass: "dashboard-block" },
            [
              _c("h2", [_vm._v("Response Options")]),
              _vm._v(" "),
              _vm._l(_vm.notification.responses, function (button) {
                return _c("div", { key: button.id }, [
                  _c("div", { staticClass: "form-item__row m-b-xl" }, [
                    _c("div", { staticClass: "form-item__field" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-group input-group-booking-detail",
                        },
                        [
                          _c("span", { staticClass: "input-group-addon" }, [
                            _vm._v("Button Label"),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "form-control" }, [
                            _vm._v(_vm._s(button.label)),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "form-item__field" }, [
                      _c(
                        "div",
                        {
                          staticClass: "input-group input-group-booking-detail",
                        },
                        [
                          _c("span", { staticClass: "input-group-addon" }, [
                            _vm._v("Assigned Tags"),
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "form-control" }, [
                            _vm._v(
                              _vm._s(_vm.tagString(button.associated_tags))
                            ),
                          ]),
                        ]
                      ),
                    ]),
                    _vm._v(" "),
                    button.users_responded && button.users_responded.length > 0
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "form-item__field form-item__field--full",
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "input-group input-group-booking-detail",
                              },
                              [
                                _c(
                                  "span",
                                  { staticClass: "input-group-addon" },
                                  [_vm._v("Talent Responses")]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-control" }, [
                                  _c(
                                    "div",
                                    { staticClass: "row" },
                                    _vm._l(
                                      button.users_responded,
                                      function (respondedUser) {
                                        return _c(
                                          "div",
                                          {
                                            key: respondedUser.id,
                                            staticClass:
                                              "col-xs-12 col-sm-6 col-lg-4",
                                          },
                                          [
                                            _c(
                                              "system-custom-notification-user-list-item",
                                              {
                                                staticClass:
                                                  "row-user-response",
                                                attrs: {
                                                  responded: respondedUser,
                                                },
                                              }
                                            ),
                                          ],
                                          1
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ]),
                              ]
                            ),
                          ]
                        )
                      : _vm._e(),
                  ]),
                ])
              }),
            ],
            2
          )
        : _vm.talentResponded
        ? _c("div", { staticClass: "dashboard-block" }, [
            _c("h2", [_vm._v("Notification Opened By")]),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "form-item__field form-item__field--full" },
              [
                _c(
                  "div",
                  { staticClass: "input-group input-group-booking-detail" },
                  [
                    _c(
                      "div",
                      { staticClass: "input-group input-group-booking-detail" },
                      [
                        _c("span", { staticClass: "input-group-addon" }, [
                          _vm._v("Talent Responses"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "form-control" }, [
                          _c(
                            "div",
                            { staticClass: "row" },
                            _vm._l(
                              _vm.notification.responded_users,
                              function (respondedUser) {
                                return _c(
                                  "div",
                                  {
                                    key: respondedUser.id,
                                    staticClass: "col-xs-12 col-sm-6 col-lg-4",
                                  },
                                  [
                                    _c("system-one-signal-user-list-item", {
                                      staticClass: "row-user-response",
                                      attrs: { responded: respondedUser },
                                    }),
                                  ],
                                  1
                                )
                              }
                            ),
                            0
                          ),
                        ]),
                      ]
                    ),
                  ]
                ),
              ]
            ),
          ])
        : _vm._e(),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }